// Contract-signalering: "Contract t/m" (contract_einddatum) is puur informatief
// en zegt niets over uit dienst of inzetbaarheid.
export const CONTRACT_HORIZON_DAYS = 30;

export function contractStatus(einddatum) {
  if (!einddatum) return null;
  const today = new Date().toISOString().slice(0, 10);
  const horizon = new Date(Date.now() + CONTRACT_HORIZON_DAYS * 864e5).toISOString().slice(0, 10);
  if (einddatum < today) return 'verlopen';
  if (einddatum <= horizon) return 'bijna';
  return 'ok';
}
